import { Component, OnInit, ViewChild } from '@angular/core';
import {  ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import {
  ColDef,
  CellEditingStartedEvent,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';

import * as moment from 'moment';

@Component({
  selector: 'app-surveys',
  templateUrl: './surveys.component.html',
  styleUrls: ['./surveys.component.css'],
  providers: [ MessageService,ConfirmationService]
})
export class SurveysComponent implements OnInit {
  totalQR:number=20;
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  showQR=false;
  pdfContent:any[]=[];
  surveyName:string='';
  QrCode='';
  webSiteUrl='';
  QRCodeUrlBase='';
  surveyId:number;
  filtroCountryList:any=[];
  filtrocountry='';
  showArchived:boolean=false;
  columns: ColDef[] = [
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
          if((params.data.status=='OPENED')||(params.data.status=='FINISHED'))
            return '';
            return '<a title="'+'Update target list'+'"><i class="pointer pi pi-pencil"></i></a>'; 
      },
      onCellClicked:function(data){ 
        
          _this.router.navigate(['/dashboard/surveys/survey-edit/update',data.data.id]);
      }   
      
    },
 
    { field: 'id',  
      headerName: '', 
      width:150,
      minWidth:150,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
          return '<a style="cursor:pointer;">Link and QR Code</a>'; 
      },
      onCellClicked:function(data){ 
      
        _this.surveyId=data.data.id;
        _this.surveyName=data.data.name;
        _this.QrCode=data.data.url+'/'+data.data.company+'/'+_this.surveyId+'/';
        _this.QRCodeUrlBase=_this.QrCode;
        _this.webSiteUrl=_this.QRCodeUrlBase+'E058D436-6F89-4EDF-8170-9C8A832CF30X';
       // _this.generateQRCode(1);
        _this.showQR=true;
      }   
    },
    { field: 'id',  
      headerName: '', 
      width:150,
      minWidth:150,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';

          return '<a style="cursor:pointer;">Compilations</a>'; 
      },
      onCellClicked:function(data){ 
        _this.router.navigateByUrl("/dashboard/surveys/surveycompilations/"+data.value);
      }   
    },
    { field: 'name',headerName: 'Name'},
    { field: 'status',headerName: 'Status' },
    { field: 'date_creation',headerName: 'Creation date',
    valueFormatter: (data) => moment(data.value).format('DD/MM/YYYY HH:mm') },
    { field: 'date_lastmodify',headerName: 'Last modify',
    valueFormatter: (data) => moment(data.value).format('DD/MM/YYYY HH:mm') },

    { field: 'rsa',headerName: 'Res.' },
    { field: 'target',headerName: 'Targets' },
    { field: 'model',headerName: 'Model' },
    { field: 'company',headerName: 'Company' },
    { field: 'id',  
      headerName: '', 
      maxWidth:150,
      minWidth:150,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
          if(params.data.url!='')
            return '<a style="cursor:pointer;" title="'+'Test survey'+'">Test survey</a>'; 
      },
      onCellClicked:function(data){ 
        window.open(data.data.url+'/'+data.data.company+'/'+data.data.id+'/0/fortest', '_blank').focus();
      }   
    },
    { field: 'total_survey',headerName: 'Results' },
    { field: 'id',  
    headerName: '', 
    maxWidth:50,
    cellRenderer: params =>    {   
        if(typeof params.value == 'undefined')
          return '';
        
          if((params.data.status!=='DRAFT')||(params.data.total_survey>0))
          return '';
   
        return '<a title="'+'Delete survey'+'"><i class="pointer pi pi-trash"></i></a>'; 
    },
    onCellClicked:function(params){ 
      if((params.data.status!=='DRAFT')||(params.data.total_survey>0))
        return;
        _this.confirmationService.confirm({
          message: 'Attention: do you confirm the delete of the survey?',
          accept: () => {
            _this.apiService.deleteSSurvey({id:params.data.id}).subscribe(data => {
              _this.addSingle('success', 'Success', 'Survey deleted');
              _this.load();
            });
          }
        });
    },
    }
  ];

  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }
  surveyslist: any[] = [];
  surveyslistAll: any[] = [];
  gridApi;
  gridColumnApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:0
  };

 
  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];

 
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.showLoadingOverlay();
    params.columnApi.applyColumnState({ state: this.defaultSortModel });
  }


  public autoSizeAll(gridColumnApi) {
    const allColumnIds = [];
    gridColumnApi.getAllColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
  
    gridColumnApi.autoSizeColumns(allColumnIds, false);
  }

  onfirstDataRendered(params) {
   this.autoSizeAll(params.columnApi);
  }


  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
  ) { }

  
  ngOnInit(): void {
    _this=this;
    this.load();
   
  }

  load(){
    this.filtroCountryList=[];
    this.filtroCountryList.push({label:'All',value:''});
    const params: any = {'archived' : this.showArchived};
    this.apiService.get('surveys/listall',params).subscribe(data => {
      this.surveyslist=data.Result;
      this.surveyslistAll=data.Result;
      this.surveyslist.forEach((r)=>{
        if(r.company){
          if(this.filtroCountryList.filter(a=>a.value==r.company).length==0){
            this.filtroCountryList.push({label:r.company,value:r.company});
          }
        }
        
      });
      this.gridApi.redrawRows();
      });
    
  }
  changeArchived(){
    this.load();
  }
  change(event){
    this.surveyslist=this.surveyslistAll;
    if((this.filtrocountry)&&(this.filtrocountry!='')){
      this.surveyslist=this.surveyslist.filter(a=>a.company==this.filtrocountry);
      this.gridApi.redrawRows();
    } 
  }


  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  chiudiQR(){
    this.showQR=false;
  }

  generateQRCode(totalQR){
    this.apiService.get('surveys/generateqrcode',{survey_id:this.surveyId,totalQR:totalQR}).subscribe(data => {
      this.pdfContent=[];
      data.Result.forEach((d,index)=>{
        if(index==0){
          this.QrCode=this.QRCodeUrlBase+d;
        }
        this.pdfContent.push({qr:this.QRCodeUrlBase+d,fit:200, margin: [100, 0]});
        if(index<data.Result.length-1){
          this.pdfContent.push({text:this.QRCodeUrlBase+d, margin: [10, 10],pageBreak: 'after'});
        } else {
          this.pdfContent.push({text:this.QRCodeUrlBase+d, margin: [10, 10]});
        }
      });
      this.showQR=true;
      return new Promise(resolve => {
        let filename='QrCodeList_'+this.surveyName+'.pdf';
        // playground requires you to assign document definition to a variable called dd
  
        var dd = {
          content: this.pdfContent
        }
        pdfMake.createPdf(dd).download(filename);
        resolve('resolved');
      }); 
     
    });
  }

  creapdf(){
    this.generateQRCode(this.totalQR);
  }

}
var _this;
